/** Minimal shape of the agent store we read (full type isn't publicly exported). */
export interface AgentStoreLike {
  activeChatId?: string
  chatState: Record<string, { messages: Array<{ role: string; content: string }> }>
}

/** Pull the most recent assistant reply so write tools can default their input. */
export function latestAssistantText(state: AgentStoreLike): string {
  const chatId = state.activeChatId
  const messages = chatId ? (state.chatState[chatId]?.messages ?? []) : []
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const message = messages[i]
    if (message.role === 'assistant' && typeof message.content === 'string' && message.content.trim()) {
      return message.content
    }
  }
  return ''
}
